//Этот компонент выводит карточку-кликер (карточка-таб) для дальнейшего использования в приложении!
//Нажатие на карточку должно перехватываться с верхнего уровня (где рендерится этот компонент) и отрисовывать нужную инфо с правой стороны экрана!
//Компонент содержит title, style(который может передаваться кастомно сверху), иконку(в виде стрелочки) и необязательные дополнительные атрибуты (ReactNode)!

import React, { FC, MouseEventHandler, useState } from "react";
import classes from "./style/UI_ITOModuleTitleCard.module.css";
import { Tag } from "antd";
import { UI_ITOTooltip } from "../indexUI";
interface UI_ModuleTitleCardProps {
  title: React.ReactNode;
  style?: React.CSSProperties;
  textDown?: React.ReactNode;
  status?: {
    color: string;
    info: string;
    id: number;
    info_color: string;
    title: string;
  };
  icon?: React.ReactNode;
  onClick?: React.MouseEventHandler<Element>;
  isArchive?: boolean;
}

export const UI_ModuleTitleCard: FC<UI_ModuleTitleCardProps> = (props) => {
  const { title, style, icon, textDown, onClick, isArchive, status } = props;
  const toogleStyle = () => {
    return isArchive !== undefined
      ? classes.cardWrapperArchive
      : classes.cardWrapper;
  };
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const handleMouseOver: MouseEventHandler<HTMLDivElement> = (event) => {
    const targetElement = event.target as HTMLDivElement;
    if (targetElement.offsetWidth < targetElement.scrollWidth) {
      setTooltipVisible(true);
    }
  };

  const handleMouseOut = () => {
    setTooltipVisible(false);
  };

  return (
    <div
      className={toogleStyle()}
      style={style}
      onClick={isArchive === undefined ? onClick : undefined}
    >
      <div className={classes.titleWrapper}>
        <div className={classes.title}>
          <UI_ITOTooltip title={title} isOpen={isTooltipVisible}>
            <div
              className={classes.title}
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >
              {title}
            </div>
          </UI_ITOTooltip>
        </div>
        <div>{textDown}</div>
        {status && (
          <Tag className={classes.tag} color={status?.color}>
            {status?.info}
          </Tag>
        )}
      </div>
      <div className={classes.iconWrapper}>{icon}</div>
    </div>
  );
};
